import { AppDispatch } from '../../store'
import {
  GET_USERS_FAILURE,
  GET_USERS_SUCCESS,
  GET_CURRENT_USER_FAILURE,
  SET_TIME_SCHEDULES,
  SET_TIME_SCHEDULES_SUCCESS,
  SET_TIME_SCHEDULES_FAILURE,
  GET_CURRENT_USER_SUCCESS,
  GET_USERS,
  GET_CURRENT_USER,
} from '../actionTypes'
import { IUser } from '../DataStore/IUser'
import {
  fetchUser,
  fetchUsers,
  updateTimeSchedules,
} from '../DataStore/UserDataStore'

const getUsersSuccess = (users: IUser[]) => {
  return {
    type: GET_USERS_SUCCESS,
    payload: {
      users,
    },
  }
}

const getUsersFailure = (errorMessage: string) => {
  return {
    type: GET_USERS_FAILURE,
    error: true,
    payload: { error: errorMessage },
  }
}

export const getUsers = () => {
  return (dispatch: AppDispatch) => {
    dispatch({ type: GET_USERS })

    return fetchUsers()
      .then(users => dispatch(getUsersSuccess(users)))
      .catch(error => dispatch(getUsersFailure(error.message)))
  }
}

const getCurrentUserSuccess = (user: IUser) => {
  return {
    type: GET_CURRENT_USER_SUCCESS,
    payload: {
      currentUser: user,
    },
  }
}

const getCurrentUserFailure = (errorMessage: string) => {
  return {
    type: GET_CURRENT_USER_FAILURE,
    error: true,
    payload: { error: errorMessage },
  }
}

export const getCurrentUser = (userId?: number) => {
  return (dispatch: AppDispatch) => {
    dispatch({ type: GET_CURRENT_USER })
    return fetchUser(userId)
      .then(user => dispatch(getCurrentUserSuccess(user)))
      .catch(error => dispatch(getCurrentUserFailure(error.message)))
  }
}

const setTimeSchedulesSuccess = (userId: number, timeSchedules: number) => {
  return {
    type: SET_TIME_SCHEDULES_SUCCESS,
    payload: {
      user_id: userId,
      time_schedules: timeSchedules,
    },
  }
}

const setTimeSchedulesFailure = (errorMessage: string) => {
  return {
    type: SET_TIME_SCHEDULES_FAILURE,
    payload: { error: errorMessage },
  }
}

export const setTimeSchedules = (userId: number, timeSchedules: number) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: SET_TIME_SCHEDULES,
      payload: {
        userId,
        timeSchedules,
      },
    })
    return updateTimeSchedules(userId, timeSchedules)
      .then(() => dispatch(setTimeSchedulesSuccess(userId, timeSchedules)))
      .catch(error => dispatch(setTimeSchedulesFailure(error.message)))
  }
}
